<span class="flex items-end">
    @if (value != undefined && column.ExtensionDisplayType == ExtensionDisplayType.IconAndText ||
    column.ExtensionDisplayType == ExtensionDisplayType.Icon) {
        <div class="relative">
            @if (pwaService.isPwa()) {
                @switch (state) {
                    @case (OfflineSyncType.Downloading) {
                        <div class="absolute -left-1 -top-1 flex size-3 items-center justify-center rounded-full bg-white">
                            <bizz-icon class="size-2.5 text-blue-400" iconName="rotate"></bizz-icon>
                        </div>
                    }
                    @case (OfflineSyncType.Downloaded) {
                        <bizz-icon class="absolute -left-1 -top-1 size-3 rounded-full bg-white text-green-500"
                                   iconName="circle-check"></bizz-icon>
                    }
                     @case (OfflineSyncType.Failed) {
                        <bizz-icon class="absolute -left-1 -top-1 size-3 rounded-full bg-white text-orange-500"
                                   iconName="rotate-exclamation"></bizz-icon>
                    }
                    @case (OfflineSyncType.None) {
                    }
                }
            }
            <bizz-extension-icon extension="{{value}}"></bizz-extension-icon>
        </div>
    }
    @if (value != undefined && column.ExtensionDisplayType == ExtensionDisplayType.IconAndText ||
    column.ExtensionDisplayType == ExtensionDisplayType.Text) {
        <span class="ml-1.5 hidden text-sm font-semibold text-widget sm:inline-block sm:text-xs">
            {{ value }}
        </span>
}
 </span>
